import commonConfig from './commonConfig'
import blockchainConfig from './blockchainConfig'
import contractAbi from "@/config/abi";

export default {
    commonConfig,
    blockchainConfig,
    contractAbi
}